export default __webpack_public_path__ + "static/media/P20002.95f9b67a.png";